DigiTickets.GiftVoucherType = Object.freeze({
    BALANCE: 'Balance',
    EXPERIENCE: 'Experience'
});
